// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-styles_footer__KhXzN"};